import { Injectable } from "@angular/core";
import { CryptocoinService } from "@main-services/currency";
import { Observable } from "rxjs";
import { MultichainTradableWallet } from "@modules/main/components/step-summary/sending-modal/entities/multichain-tradable-wallet";
import { CryptocoinsState } from "@modules/+new/payments/shared-payments/services/cryptocoins-state.service";
import { map } from "rxjs/operators";
import { Tradable } from "@models/interfaces/tradable";
import { convertTradableToFiat } from "@helpers/tradable-convert";
import { AccountService } from "@modules/account/services/account.service";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";

@Injectable()
export class TradableToListHelperService {
	constructor(
		private readonly cryptocoinService: CryptocoinService,
		private readonly paymentCryptoState: CryptocoinsState,
		private readonly accountService: AccountService,
		private readonly walletService: TradableWalletListService
	) {}

	public getCryptoWalletInfo$(): Observable<MultichainTradableWallet[]> {
		return this.paymentCryptoState.availableCryptoWithdrawalList$.pipe(
			map((cryptoList) =>
				cryptoList
					.map((newC) => {
						const oldC = this.cryptocoinService.list.find((item) => item.getPid() === newC.pid);
						if (oldC) {
							return {
								asset: newC,
								walletSum: this.getWalletSum(oldC),
								walletSumFiat: this.calculateWalletSum(oldC)
							};
						}
					})
					.filter((item) => item?.walletSum > 0)
			)
		);
	}

	public getWalletSum(c: Tradable): number {
		return this.getWallets(c).reduce((val: number, w: TradableWallet) => val + w.getBalance(), 0);
	}

	protected calculateWalletSum(tradable: Tradable): number {
		return convertTradableToFiat(tradable, this.getWalletSum(tradable), this.accountService.getDefaultFiat());
	}

	private getWallets(c: Tradable): TradableWallet[] {
		let wallets: TradableWallet[] = this.walletService.list;
		wallets = wallets.filter((w: TradableWallet) => w.getCurrencyId() === c.getId() && !w.isDeleted());
		return wallets;
	}
}
